import { unsetToken } from "./initReducer";
import commonUtils from "../utils/CommonUtils";
import produce from "immer";
import history from "../history";
import { message } from "antd";

//=================== ACTION TYPES ======================
const NOT_AUTHORIZED = "NOT_AUTHORIZED";
const GET_NEWS_START = "GET_NEWS_START";
const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS";
const GET_NEWS_FAIL = "GET_NEWS_FAIL";
const GET_NEWS_TYPES_START = "GET_NEWS_TYPES_START";
const GET_NEWS_TYPES_SUCCESS = "GET_NEWS_TYPES_SUCCESS";
const GET_NEWS_TYPES_FAIL = "GET_NEWS_TYPES_FAIL";
const GET_NEW_FLAG_COUNTS_START = "GET_NEW_FLAG_COUNTS_START";
const GET_NEW_FLAG_COUNTS_SUCCESS = "GET_NEW_FLAG_COUNTS_SUCCESS";
const GET_NEW_FLAG_COUNTS_FAIL = "GET_NEW_FLAG_COUNTS_FAIL";
const CREATE_NEWS_START = "CREATE_NEWS_START";
const CREATE_NEWS_SUCCESS = "CREATE_NEWS_SUCCESS";
const CREATE_NEWS_FAIL = "CREATE_NEWS_FAIL";
const DELETE_NEWS_START = "DELETE_NEWS_START";
const DELETE_NEWS_SUCCESS = "DELETE_NEWS_SUCCESS";
const DELETE_NEWS_FAIL = "DELETE_NEWS_FAIL";
const UPDATE_NEWS_START = "UPDATE_NEWS_START";
const UPDATE_NEWS_SUCCESS = "UPDATE_NEWS_SUCCESS";
const UPDATE_NEWS_FAIL = "UPDATE_NEWS_FAIL";
const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";

//=================== ACTION CREATORS ======================
const notAuthorized = () => ({
    type: NOT_AUTHORIZED,
});

const getNewsStart = () => ({
    type: GET_NEWS_START,
});

const getNewsSuccess = (payload) => ({
    type: GET_NEWS_SUCCESS,
    payload,
});

const appendNewsSuccess = (payload) => ({
    type: "APPEND_NEWS_SUCCESS",
    payload,
});

const getNewsFail = (payload) => ({
    type: GET_NEWS_FAIL,
    payload,
});

const getNewsTypesStart = () => ({
    type: GET_NEWS_TYPES_START,
});

const getNewsTypesSuccess = (payload) => ({
    type: GET_NEWS_TYPES_SUCCESS,
    payload,
});

const getNewsTypesFail = (payload) => ({
    type: GET_NEWS_TYPES_FAIL,
    payload,
});

const createNewsStart = () => ({
    type: CREATE_NEWS_START,
});

const createNewsSuccess = (payload) => ({
    type: CREATE_NEWS_SUCCESS,
    payload,
});

const createNewsFail = (payload) => ({
    type: CREATE_NEWS_FAIL,
    payload,
});

const deleteNewsStart = () => ({
    type: DELETE_NEWS_START,
});

const deleteNewsSuccess = (payload) => ({
    type: DELETE_NEWS_SUCCESS,
    payload,
});

const deleteNewsFail = (payload) => ({
    type: DELETE_NEWS_FAIL,
    payload,
});

const updateNewsStart = () => ({
    type: UPDATE_NEWS_START,
});

const updateNewsSuccess = (payload) => ({
    type: UPDATE_NEWS_SUCCESS,
    payload,
});

const updateNewsFail = (payload) => ({
    type: UPDATE_NEWS_FAIL,
    payload,
});

const getNewFlagCountsStart = () => ({
    type: GET_NEW_FLAG_COUNTS_START,
});

const getNewFlagCountsSuccess = (payload) => ({
    type: GET_NEW_FLAG_COUNTS_SUCCESS,
    payload,
});

const getNewFlagCountsFail = (payload) => ({
    type: GET_NEW_FLAG_COUNTS_FAIL,
    payload,
});

export const clearErrorMessage = () => ({
    type: CLEAR_ERROR_MESSAGE,
});

//=================== thunks ======================
export function getNews(pageNumber = 1, pageRowCount = 10, newsType = 0, isActive = true, isDraft = false, isLoadMore = false) {
    return (dispatch, getState) => {
        dispatch(getNewsStart());

        const payload = {
            PageNumber: pageNumber,
            PageRowCount: pageRowCount,
            NewsType: newsType,
            IsActive: isActive,
            IsDraft: isDraft,
        };

        return commonUtils
            .apiCall("post", "News/GetNews", payload)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    const result = response.data;
                    if (result.resultCode === 3) {
                        history.push("/signin");
                        dispatch(unsetToken());
                        dispatch(notAuthorized());
                        return;
                    }
                    if (isLoadMore) {
                        dispatch(
                            appendNewsSuccess({
                                news: result.news || [],
                                rowCount: result.rowCount || 0,
                                showNewFlagCount: result.showNewFlagCount || 0,
                            }),
                        );
                    } else {
                        dispatch(
                            getNewsSuccess({
                                news: result.news || [],
                                rowCount: result.rowCount || 0,
                                showNewFlagCount: result.showNewFlagCount || 0,
                            }),
                        );
                    }
                } else {
                    dispatch(getNewsFail(null));
                }
            })
            .catch((error) => {
                dispatch(getNewsFail("Կապի խնդիր. խնդրում ենք կրկին փորձել"));
            });
    };
}

export function getNewsTypes() {
    return (dispatch, getState) => {
        dispatch(getNewsTypesStart());

        commonUtils
            .apiCall("get", "News/GetNewsType", {})
            .then((response) => {
                if (response.status === 200 && response.data) {
                    if (response.data.resultCode === 3) {
                        history.push("/signin");
                        dispatch(unsetToken());
                        dispatch(notAuthorized());
                        return;
                    }
                    const newsTypes = Array.isArray(response.data) ? response.data : response.data.result || [];
                    dispatch(getNewsTypesSuccess({ newsTypes }));
                }
            })
            .catch((error) => {
                dispatch(getNewsTypesFail("Կապի խնդիր. խնդրում ենք կրկին փորձել"));
            });
    };
}

export function getNewFlagCountsByType() {
    return (dispatch, getState) => {
        dispatch(getNewFlagCountsStart());

        commonUtils
            .apiCall("get", "News/GetShowNewFlagCountDependingOnType", {})
            .then((response) => {
                if (response.status === 200 && response.data) {
                    if (response.data.resultCode === 3) {
                        history.push("/signin");
                        dispatch(unsetToken());
                        dispatch(notAuthorized());
                        return;
                    }
                    const countsArray = Array.isArray(response.data) ? response.data : response.data.result || [];
                    const newFlagCounts = {};
                    countsArray.forEach((item) => {
                        newFlagCounts[item.key] = parseInt(item.value) || 0;
                    });
                    dispatch(getNewFlagCountsSuccess({ newFlagCounts }));
                }
            })
            .catch((error) => {
                dispatch(getNewFlagCountsFail("Կապի խնդիր. խնդրում ենք կրկին փորձել"));
            });
    };
}

export function createNews(newsData) {
    return (dispatch, getState) => {
        dispatch(createNewsStart());

        return commonUtils
            .apiCall("post", "News/CreateNews", newsData)
            .then((response) => {
                if (response.data.resultCode === 1) {
                    dispatch(
                        createNewsSuccess({
                            id: response.data.id,
                            details: response.data.details || [],
                        }),
                    );
                    message.success(newsData.IsDraft ? "Նյութը պահպանվել է սևագիր կարգավիճակով" : "Նյութը հաջողությամբ հրապարակվել է");
                    return response.data;
                } else if (response.data.resultCode === 3) {
                    history.push("/signin");
                    dispatch(unsetToken());
                    dispatch(notAuthorized());
                } else {
                    const errorMessage = response.data.details && response.data.details[0];
                    dispatch(createNewsFail(errorMessage));
                    return Promise.reject(new Error(errorMessage));
                }
            })
            .catch((error) => {
                dispatch(createNewsFail("Կապի խնդիր. խնդրում ենք կրկին փորձել"));
                return Promise.reject(error);
            });
    };
}

export function deleteNews(id) {
    return (dispatch, getState) => {
        dispatch(deleteNewsStart());

        return commonUtils
            .apiCall("post", `News/DeleteNews?id=${id}`)
            .then((response) => {
                if (response.data.resultCode === 1) {
                    dispatch(
                        deleteNewsSuccess({
                            id: response.data.id,
                            details: response.data.details || [],
                        }),
                    );
                    message.success("Նյութը հաջողությամբ հեռացվել է");
                    return response.data;
                } else if (response.data.resultCode === 3) {
                    history.push("/signin");
                    dispatch(unsetToken());
                    dispatch(notAuthorized());
                } else {
                    const errorMessage = response.data.details && response.data.details[0];
                    dispatch(deleteNewsFail(errorMessage));
                    return Promise.reject(new Error(errorMessage));
                }
            })
            .catch((error) => {
                dispatch(deleteNewsFail("Կապի խնդիր. խնդրում ենք կրկին փորձել"));
                return Promise.reject(error);
            });
    };
}

export function updateNews(newsData) {
    return (dispatch, getState) => {
        dispatch(updateNewsStart());

        const id = newsData.Id;
        const { Id, ...requestBody } = newsData;

        return commonUtils
            .apiCall("post", `News/UpdateNews?id=${id}`, requestBody)
            .then((response) => {
                if (response.data.resultCode === 1) {
                    dispatch(
                        updateNewsSuccess({
                            id: response.data.id,
                            details: response.data.details || [],
                        }),
                    );
                    message.success(newsData.IsDraft ? "Նյութը պահպանվել է սևագիր կարգավիճակով" : "Նյութը հաջողությամբ թարմացվել է");
                    return response.data;
                } else if (response.data.resultCode === 3) {
                    history.push("/signin");
                    dispatch(unsetToken());
                    dispatch(notAuthorized());
                } else {
                    const errorMessage = response.data.details && response.data.details[0];
                    dispatch(updateNewsFail(errorMessage));
                    return Promise.reject(new Error(errorMessage));
                }
            })
            .catch((error) => {
                dispatch(updateNewsFail("Կապի խնդիր. խնդրում ենք կրկին փորձել"));
                return Promise.reject(error);
            });
    };
}

//=================== State ======================
const initialState = {
    loading: {
        type: "",
        loading_state: false,
    },
    error_message: {
        type: "",
        message: "",
    },
    news: [],
    newsTypes: [],
    newFlagCounts: {},
    createdNewsId: null,
    currentPage: 1,
    totalRowCount: 0,
};

export default function newsReducer(state = initialState, action) {
    switch (action.type) {
        case NOT_AUTHORIZED:
            return produce(state, (draft) => {
                draft.loading.type = "";
                draft.loading.loading_state = false;
                draft.error_message.type = "NotAuthorized";
                draft.error_message.message = "Խնդրում ենք կրկին մուտք գործել համակարգ";
            });
        case GET_NEWS_START:
            return produce(state, (draft) => {
                draft.loading.type = "GetNews";
                draft.loading.loading_state = true;
            });
        case GET_NEWS_SUCCESS:
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.loading.type = "";
                draft.news = action.payload.news;
                draft.totalRowCount = action.payload.rowCount;
                draft.currentPage = 1;
            });
        case "APPEND_NEWS_SUCCESS":
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.loading.type = "";
                draft.news = draft.news.concat(action.payload.news);
                draft.totalRowCount = action.payload.rowCount;
                draft.currentPage += 1;
            });
        case GET_NEWS_FAIL:
            return produce(state, (draft) => {
                draft.error_message.type = "GetNews";
                draft.error_message.message = action.payload;
                draft.loading.loading_state = false;
                draft.loading.type = "";
            });
        case GET_NEWS_TYPES_START:
            return produce(state, (draft) => {
                draft.loading.type = "GetNewsTypes";
                draft.loading.loading_state = true;
            });
        case GET_NEWS_TYPES_SUCCESS:
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.newsTypes = action.payload.newsTypes;
            });
        case GET_NEWS_TYPES_FAIL:
            return produce(state, (draft) => {
                draft.error_message.type = "GetNewsTypes";
                draft.error_message.message = action.payload;
                draft.loading.loading_state = false;
            });
        case GET_NEW_FLAG_COUNTS_START:
            return produce(state, (draft) => {
                draft.loading.type = "GetNewFlagCounts";
                draft.loading.loading_state = true;
            });
        case GET_NEW_FLAG_COUNTS_SUCCESS:
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.newFlagCounts = action.payload.newFlagCounts;
            });
        case GET_NEW_FLAG_COUNTS_FAIL:
            return produce(state, (draft) => {
                draft.error_message.type = "GetNewFlagCounts";
                draft.error_message.message = action.payload;
                draft.loading.loading_state = false;
            });
        case CREATE_NEWS_START:
            return produce(state, (draft) => {
                draft.loading.type = "CreateNews";
                draft.loading.loading_state = true;
            });
        case CREATE_NEWS_SUCCESS:
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.createdNewsId = action.payload.id;
                draft.error_message.type = "";
                draft.error_message.message = "";
            });
        case CREATE_NEWS_FAIL:
            return produce(state, (draft) => {
                draft.error_message.type = "CreateNews";
                draft.error_message.message = action.payload;
                draft.loading.loading_state = false;
            });
        case DELETE_NEWS_START:
            return produce(state, (draft) => {
                draft.loading.type = "DeleteNews";
                draft.loading.loading_state = true;
            });
        case DELETE_NEWS_SUCCESS:
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.error_message.type = "";
                draft.error_message.message = "";
            });
        case DELETE_NEWS_FAIL:
            return produce(state, (draft) => {
                draft.error_message.type = "DeleteNews";
                draft.error_message.message = action.payload;
                draft.loading.loading_state = false;
            });
        case UPDATE_NEWS_START:
            return produce(state, (draft) => {
                draft.loading.type = "UpdateNews";
                draft.loading.loading_state = true;
            });
        case UPDATE_NEWS_SUCCESS:
            return produce(state, (draft) => {
                draft.loading.loading_state = false;
                draft.error_message.type = "";
                draft.error_message.message = "";
            });
        case UPDATE_NEWS_FAIL:
            return produce(state, (draft) => {
                draft.error_message.type = "UpdateNews";
                draft.error_message.message = action.payload;
                draft.loading.loading_state = false;
            });
        case CLEAR_ERROR_MESSAGE:
            return produce(state, (draft) => {
                draft.error_message.type = "";
                draft.error_message.message = "";
            });
        default:
            return state;
    }
}
